<template>
    <button @click="toggleLike" :class="{ 'text-brand-red': isLiked, 'text-brand-red': !isLiked }"
        class="flex items-center focus:outline-none hover:opacity-75 transition-colors text-brand-red">
        <svg xmlns="http://www.w3.org/2000/svg" :fill="isLiked ? 'currentColor' : 'none'" viewBox="0 0 24 24"
            stroke="currentColor" class="w-10 h-10">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
        </svg>
        <!-- <span class="ml-2">{{ likesCount }}</span> -->
    </button>
    <span v-if="likesCount > 0" class="mt-1">
            {{ likesCount }} {{ likesCount === 1 ? 'like' : 'likes' }}
        </span>
</template>

<script>
    export default {
        props: {
            postId: {
                required: true,
                type: Number,
            },
            initialIsLiked: {
                required: true,
                type: Boolean,
            },
            initialLikesCount: {
                required: true,
                type: Number,
            },
        },
        data() {
            return {
                isLiked: this.initialIsLiked,
                likesCount: this.initialLikesCount,
            };
        },
        methods: {
            async toggleLike() {
                try {
                    const response = await axios.post(`/p/${this.postId}/like`);
                    if (response.data.success) {
                        this.isLiked = response.data.liked;
                        this.likesCount = response.data.likesCount;
                    } else {
                        console.error(response.data.message);
                    }
                } catch (error) {
                    console.error(
                        "Error toggling like:",
                        error.response?.data?.message || error.message
                    );
                }
            },
        },
    };
</script>
